import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-add-truck-category",
  templateUrl: "./admin-add-truck-category.component.html",
  styleUrls: ["./admin-add-truck-category.component.css"],
})
export class AdminAddTruckCategoryComponent implements OnInit {
  file: any = "";
  profileImage: any;
  addCategoryForm!: FormGroup;
  token: any;
  profileImg: boolean = true;
  uploadImg: boolean = false;
  crossImg: boolean = false;
  loading: boolean = false;
  categImageloading: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminAddTruckCategoryComponent>,
    private services: AdminService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.addCategoryForm = this.formBuilder.group({
      truck_category_name: [
        "",
        [
          Validators.required,
          Validators.pattern("^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
      category_description: [
        "",
        [
          Validators.required,
          Validators.pattern("^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$"),
        ],
      ],
      category_image: [
        null,
        Validators.required,
      ],
    });
  }
  close() {
    this.matdialogref.close();
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.loading = true;
    this.categImageloading = true;
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (this.file && !allowedTypes.includes(this.file.type)) {
      this.loading = false;
      this.categImageloading = false;
      this.snackBar.open("Invalid file format. Upload JPG, JPEG, or PNG.", "Close", {
        duration: 4000,
      });
      return;
    }
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 201) {
          this.loading = false;
          this.categImageloading = false;
          this.profileImage = response.body.image_link;
          this.profileImg = false;
          this.uploadImg = true;
          this.crossImg = true;
          this.addCategoryForm.get("category_image")?.updateValueAndValidity();
          this.snackBar.open("Image uploaded successfully!", "OK", {
            duration: 4000,
          });
        }
      },
      (error) => {
        this.loading = false;
        this.categImageloading = false;
        if (["jwt malformed", "jwt expired", "invalid signature"].includes(error.error.message)) {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message || "Image upload failed.", "Fail", {
          duration: 5000,
        });
      }
    );
  }

  public addTruckCat(event: any) {
    if (!this.addCategoryForm.valid || this.loading) {
      this.addCategoryForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    (event.target as HTMLButtonElement).disabled = true; // Disable button instantly
    const trucCatgObj = {
      truck_category_name: this.addCategoryForm.value.truck_category_name,
      category_description: this.addCategoryForm.value.category_description,
      category_image: this.profileImage,
    };
    if (trucCatgObj.category_image == undefined) {
      this.snackBar.open("Please upload truck image", "Fail", {
        duration: 3000,
      });
      return;
    }
    this.services.AddTruckCatg(trucCatgObj, this.token).subscribe(
      (response: any) => {
        if (response.status == 201) {
          this.snackBar.open("Truck category added successfully", "Success", {
            duration: 5000,
          });
          this.loading = false;
          localStorage.setItem("ProfilePic", this.profileImage);
          this.truckCategoryGet();
          this.matdialogref.close();
        }
      },
      (error) => {
        this.loading = false;
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  truckCategoryGet() {
    this.services.getTrucksCatg(this.token).subscribe((response: any) => {});
  }
  removeImg() {
    this.file = null;
    this.uploadImg = false;
    this.profileImg = true;
    this.crossImg = false; 
    this.uploadImg = false;
    this.profileImage = "";
    this.addCategoryForm.patchValue({
      category_image: null,
    });
    this.addCategoryForm.get("category_image")?.updateValueAndValidity();
  }
}
